<template>
  <label class="checkbox" @mousemove="handleMouseMove">
    <input :checked="checked" @change="handleChange" type="checkbox" />
    <span class="box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="11"
        viewBox="0 0 12 11"
      >
        <path
          fill="#fff"
          d="M11.796 1.667l-6.075 8.87c-.015.022-.038.032-.053.052-.027.033-.042.072-.072.102-.035.035-.078.05-.116.08a1.083 1.083 0 0 1-.419.205c-.02.005-.039.01-.06.013a.93.93 0 0 1-.329 0 1.154 1.154 0 0 1-.113-.02.878.878 0 0 1-.14-.058c-.069-.028-.142-.042-.206-.085a1.043 1.043 0 0 1-.372-.47L.248 6.246c-.36-.413-.302-1.095.13-1.525.431-.43 1.074-.444 1.434-.031L4.78 8.085 9.994.47a1.098 1.098 0 0 1 1.508-.289c.498.331.629.996.294 1.486z"
        />
      </svg>
    </span>
    <span
      v-tooltip.top-center="{
        content: text ? text : null,
        classes: elepsize ? tooltipClassName : ''
      }"
      class="text"
      ref="text"
      >{{ text }}</span
    >
  </label>
</template>
<script>
export default {
  name: "Checkbox",
  props: {
    text: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    checked: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      elepsize: false,
      tooltipClassName: "on-checkbox"
    };
  },

  methods: {
    handleMouseMove(e) {
      this.truncateText();
      if (this.index % 5 === 4) {
        this.tooltipClassName = "on-checkbox-right-side";
      }
      this.tooltipClassName +=
        this.index % 5 === 4
          ? ` on-checkbox-right-side-${this.text.length - 17}`
          : "";
      this.$forceUpdate();
    },
    handleChange(e) {
      this.$emit("changed", this.text, e.target.checked);
    },

    truncateText() {
      if (this.$refs.text.offsetWidth < this.$refs.text.scrollWidth) {
        this.elepsize = true;
      } else {
        this.elepsize = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.checkbox {
  padding-left: 25px;
  position: relative;
  color: #666666;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  cursor: pointer;
  height: 20px;
  &:hover {
    .text {
      color: #a42a7b;
    }
    .box {
      border-color: #a42a7b;
    }
  }
  input {
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 1px;
    clip: rect(0, 0, 0, 0);
    background-color: transparent;
  }
  .box {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 19px;
    height: 19px;
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background-color: #ffffff;
    svg {
      position: relative;
      left: 4px;
      top: 4px;
      display: none;
    }
  }
  input:checked ~ .box {
    background-color: #a42a7b;
    border: none;
    svg {
      display: block;
    }
  }
  .text {
    user-select: none;
    position: relative;
    left: 4px;
    top: -2px;
    overflow-x: hidden;
    overflow-y: hidden;
    text-overflow: ellipsis;
    height: 20px;
    width: calc(100% - 1px); //for tooltip to work on 20 symbols word
    white-space: nowrap;
    display: inline-block;
  }
}
</style>
